import * as React from 'react';
import { recipes } from './Dataset';
import { IMaterial, IRecipe } from './Interfaces';
import { Link } from './Link';

interface IRecipeProps {
  material: IMaterial;
  recipe: IRecipe;
}

export class Recipe extends React.Component<IRecipeProps> {
  constructor(props: any, context: any) {
    super(props, context);
  }

  public render() {
    const { material, recipe } = this.props;
    return (
      <li className="recipe">
        <div className="title">
          <img
            height="20"
            className="image"
            src={`https://raw.githubusercontent.com/csharptest/nms/master/img/${material.id}.png`}
          />
          {recipe.name}
        </div>
        <div className="inputs">
          {Object.keys(recipe.input)
            .sort((a, b) => recipes[a].name > recipes[b].name ? 1 : -1)
            .map((input) => this.renderInput(input, recipe.input[input]))}
        </div>
        <div className="output">{material.name} (x{recipe.output} in {recipe.time})</div>
      </li>
    );
  }

  public renderInput(type: string, amount: number) {
    const item = recipes[type];
    const label = item.name + (amount > 1 ? ` (x${amount})` : '');
    return (
      <div key={type}>
        <Link icon={type} label={label} location={`#${type}`} />
      </div>
    );
  }
}

export default Recipe;



// WEBPACK FOOTER //
// ./src/Recipe.tsx